import type {
  Position,
  CreatePositionRequest,
  UpdatePositionRequest,
} from '~/constants/positionTypes'
import apiUtil, { throwApiError } from '~/utils/apiUtils'

const { get, post, put, del } = apiUtil()

class PositionAPI {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {}

  // POST method to create a position
  async createPosition(newPosition: CreatePositionRequest): Promise<Position> {
    try {
      const response = await post('/position', newPosition)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error creating position:', error)
      throw error
    }
  }

  async updatePosition(
    positionId: string,
    position: UpdatePositionRequest,
  ): Promise<Position> {
    try {
      const response = await put(`/position/${positionId}`, position)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error updating position:', error)
      throw error
    }
  }

  async getPositionList(): Promise<Position[]> {
    try {
      const response = await get('/position')

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json ?? []
    } catch (error) {
      console.error('Error getting position list:', error)
      throw error
    }
  }

  async getPosition(positionId: string): Promise<Position> {
    try {
      const response = await get(`/position/${positionId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json
    } catch (error) {
      console.error('Error getting position:', error)
      throw error
    }
  }

  async regenerateJobDescription(positionId: string): Promise<string> {
    try {
      const response = await get(`/job-description/generate/${positionId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json.jobDescription
    } catch (error) {
      console.error('Error regenerating job description:', error)
      throw error
    }
  }

  async deletePosition(positionId: string): Promise<void> {
    try {
      const response = await del(`/position/${positionId}`)

      if (!response.ok) {
        await throwApiError(response)
      }
    } catch (error) {
      console.error('Error deleting position:', error)
      throw error
    }
  }
}

const positionApi = new PositionAPI()

export default positionApi
